
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("2cf0m", function(module, exports) {
module.exports = new URL("linkedin.0d89ad4a.svg", import.meta.url).toString();

});

parcelRegister("ce1Uw", function(module, exports) {
module.exports = new URL("instagram.597efbb8.svg", import.meta.url).toString();

});

parcelRegister("3088F", function(module, exports) {
module.exports = new URL("tiktok.54c5d2d8.svg", import.meta.url).toString();

});

parcelRegister("4LQ58", function(module, exports) {
module.exports = new URL("youtube.c6f2b66a.svg", import.meta.url).toString();

});

parcelRegister("5mb27", function(module, exports) {
module.exports = new URL("whatsapp.aae7b85a.svg", import.meta.url).toString();

});

parcelRegister("abAuF", function(module, exports) {
module.exports = new URL("messenger.3f358254.svg", import.meta.url).toString();

});

parcelRegister("ahuEg", function(module, exports) {
module.exports = new URL("facebook.448ff7d0.svg", import.meta.url).toString();

});

parcelRegister("9BaSP", function(module, exports) {
module.exports = new URL("success-icon.feb4a917.svg", import.meta.url).toString();

});

parcelRegister("cw0tT", function(module, exports) {
module.exports = new URL("incorrect-icon.ebb389cd.svg", import.meta.url).toString();

});

parcelRegister("iVG8G", function(module, exports) {
module.exports = new URL("threads.6a7f62ca.svg", import.meta.url).toString();

});

var $859c5d141a57b1e3$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gW9mT\",\"index.b0ab1cf9.js\",\"kJKHU\",\"linkedin.0d89ad4a.svg\",\"6LCgP\",\"instagram.597efbb8.svg\",\"jGoST\",\"tiktok.54c5d2d8.svg\",\"gFhx0\",\"youtube.c6f2b66a.svg\",\"7NK6X\",\"whatsapp.aae7b85a.svg\",\"7QPL2\",\"messenger.3f358254.svg\",\"3FCkq\",\"facebook.448ff7d0.svg\",\"87qhF\",\"success-icon.feb4a917.svg\",\"3lFoH\",\"incorrect-icon.ebb389cd.svg\",\"cjTGX\",\"sync-white.892a42b3.svg\",\"7GBQ3\",\"sync-black.85882c9a.svg\",\"gpJSU\",\"threads.6a7f62ca.svg\",\"aWQRv\",\"index.4f865251.js\"]"));


var $fmRoT = parcelRequire("fmRoT");

window.LINKEDIN_ICON = new URL((parcelRequire("2cf0m"))).href;

window.INSTAGRAM_ICON = new URL((parcelRequire("ce1Uw"))).href;

window.TIKTOK_ICON = new URL((parcelRequire("3088F"))).href;

window.YOUTUBE_ICON = new URL((parcelRequire("4LQ58"))).href;

window.WHATSAPP_ICON = new URL((parcelRequire("5mb27"))).href;

window.MESSENGER_ICON = new URL((parcelRequire("abAuF"))).href;

window.FACEBOOK_ICON = new URL((parcelRequire("ahuEg"))).href;

window.THREADS_ICON = new URL((parcelRequire("iVG8G"))).href;

window.SUCCESS_ICON = new URL((parcelRequire("9BaSP"))).href;

window.INCORRECT_ICON = new URL((parcelRequire("cw0tT"))).href;
var $a5dd9aa30134cc97$exports = {};
$a5dd9aa30134cc97$exports = new URL("sync-white.892a42b3.svg", import.meta.url).toString();


window.WHITE_SYNC_ICON = new URL($a5dd9aa30134cc97$exports).href;
var $3b03bff8df02a33f$exports = {};
$3b03bff8df02a33f$exports = new URL("sync-black.85882c9a.svg", import.meta.url).toString();


window.BLACK_SYNC_ICON = new URL($3b03bff8df02a33f$exports).href;
const $09e42c3b4c1f2ea9$var$GRAY_ICON = 'https://cdn.hyperdev.com/us-east-1%3A3d31b21c-01a0-4da2-8827-4bc6e88b7618%2Ficon-gray.svg';
const $09e42c3b4c1f2ea9$var$onDone = ()=>{
    console.log('on done');
};
const $09e42c3b4c1f2ea9$var$syncToThisBoard = (t, opts)=>{
    return t.popup({
        callback: $09e42c3b4c1f2ea9$var$onDone,
        title: 'Sync Socials to the Board',
        url: './sync-socials.html',
        height: 350
    });
};
window.TrelloPowerUp.initialize({
    'authorization-status': (t, options)=>{
        // return a promise that resolves to the object with
        // a property 'authorized' being true/false
        // you can also return the object synchronously if you know
        // the answer synchronously
        return t.member('id', 'fullName').then((member)=>{
            return (0, $fmRoT.default).post('https://social.businessstorylab.com/api/trello-login', {
                trelloMemberId: member.id,
                trelloUserName: member.fullName
            }).then((response)=>{
                return {
                    authorized: response.data
                };
            });
        });
    },
    'show-authorization': (t, options)=>{
        // return what to do when a user clicks the 'Authorize Account' link
        // from the Power-Up gear icon which shows when 'authorization-status'
        // returns { authorized: false }
        // in this case we would open a popup
        return t.popup({
            title: 'My Auth Popup',
            url: './sign-up.html',
            height: 140
        });
    },
    'board-buttons': (t, opts)=>{
        return [
            {
                icon: {
                    dark: window.WHITE_SYNC_ICON,
                    light: window.BLACK_SYNC_ICON
                },
                text: 'Sync to this board',
                callback: $09e42c3b4c1f2ea9$var$syncToThisBoard,
                condition: 'edit'
            }
        ];
    },
    //additional card data ->  'dateLastActivity', 'due', 'dueComplete', 'name', 'url', 'desc', 'shortLink'
    'card-badges': (t, ops)=>{
        return t.card('id').then((card)=>{
            return t.member('id').then((member)=>{
                (0, $fmRoT.default).defaults.headers.common['BSL-Social-Token'] = "k8jKR9E7-VlNKJk54A-xMkve2c-LDIY";
                return (0, $fmRoT.default).get('https://social.businessstorylab.com/api/social/posts-by-card', {
                    params: {
                        foreignUserId: member.id,
                        cardId: card.id
                    }
                }).then((response)=>{
                    if (response.data) {
                        let badges = [];
                        response.data.forEach((post)=>{
                            let iconName = post.platform.toUpperCase() + '_ICON';
                            badges.push({
                                text: post.status,
                                icon: window[iconName],
                                monochrome: false
                            });
                        });
                        return badges;
                    }
                });
            });
        });
    },
    'card-back-section': (t, options)=>{
        return t.card('id').then((card)=>{
            return t.member('id', 'fullName').then(async (member)=>{
                let authorized = await (0, $fmRoT.default).post('https://social.businessstorylab.com/api/trello-login', {
                    trelloMemberId: member.id,
                    trelloUserName: member.fullName
                }).then((response)=>{
                    return response.data;
                });
                if (authorized === true) return {
                    title: 'Automate Socials',
                    icon: $09e42c3b4c1f2ea9$var$GRAY_ICON,
                    content: {
                        type: 'iframe',
                        url: t.signUrl(`./section.html?trello-member-id=${member.id}&trello-member-name=${member.fullName}&trello-card-id=${card.id}`),
                        height: 350
                    }
                };
                else return {
                    title: 'Automate Socials',
                    icon: $09e42c3b4c1f2ea9$var$GRAY_ICON,
                    content: {
                        type: 'iframe',
                        url: t.signUrl(`./sign-up.html`),
                        height: 230
                    }
                };
            });
        });
    }
});


//# sourceMappingURL=index.b0ab1cf9.js.map
